module.exports = __webpack_public_path__ + "img/marketSituation.8d77ff18.png";